import React from 'react';
import { motion } from 'framer-motion';
import { GearIcon, ShieldIcon, CheckIcon } from './icons';
export function UniqueMechanism() {
  const points = ['Un solo punto de contacto — Geovanny directamente', 'Presupuesto claro antes de empezar', 'Disponible 24/7 para emergencias y seguimiento', 'Trabajo local — conocemos MD, DC y VA', 'Satisfacción garantizada antes del pago final'];
  return <section className="py-24 bg-brand-bg-dark relative overflow-hidden" data-id="element-297">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-brand-gold/5 rounded-full blur-3xl" data-id="element-298"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-green/5 rounded-full blur-3xl" data-id="element-299"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-300">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-301">
          <div className="text-center mb-16" data-id="element-302">
            <p className="text-brand-gold font-heading text-xl tracking-widest uppercase mb-4" data-id="element-303">
              Esto es lo que hace diferente a BENITEZ:
            </p>
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-304">
              <GearIcon className="w-10 h-10 text-brand-gold" data-id="element-305" />
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-heading font-bold text-white" data-id="element-306">
                El Sistema de Manos Confiables
              </h2>
              <ShieldIcon className="w-10 h-10 text-brand-gold hidden sm:block" data-id="element-307" />
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} className="bg-gradient-to-br from-brand-bg-light to-brand-bg-dark border border-brand-gold/20 rounded-2xl p-8 sm:p-12 shadow-2xl" data-id="element-308">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="mb-10 text-center" data-id="element-309">
              <p className="text-2xl sm:text-3xl text-white font-medium leading-relaxed" data-id="element-310">
                <span className="text-brand-gold font-heading font-bold" data-id="element-311">
                  Geovanny
                </span>{' '}
                — el dueño — está involucrado personalmente en cada trabajo.
              </p>
              <p className="text-xl text-gray-400 mt-6 max-w-2xl mx-auto" data-id="element-312">
                No hay intermediarios. No hay subcontratistas anónimos. No hay
                excusas.
              </p>
            </motion.div>

            <div className="grid gap-6 md:grid-cols-2 lg:gap-8 mt-12" data-id="element-313">
              {points.map((point, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: index % 2 === 0 ? -30 : 30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.12,
              ease: 'easeOut'
            }} className={`flex items-start gap-4 bg-brand-bg-dark/50 p-6 rounded-xl border border-brand-gold/10 ${index === points.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-314">
                  <div className="bg-brand-green/20 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-315">
                    <CheckIcon className="w-6 h-6 text-brand-green" data-id="element-316" />
                  </div>
                  <p className="text-lg sm:text-xl text-gray-200 font-medium" data-id="element-317">
                    {point}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}